/**
 *	BLOCK: FEATURED CASE STUDY
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".ash-block.featured-case-study").forEach(function (el) {
		// Completely outside the viewport
        if (!isElementInViewport(el)) {
            let picture = el.querySelector(":scope .picture-wrapper");
            if (picture) {
                picture.classList.remove("slide-right");
            }
            el.querySelector(":scope .copy").classList.remove("slide-left");
		}
	});
})();
// Add classes when any part within viewport
var slideFeaturedCaseStudies = function () {
	document.querySelectorAll(".ash-block.featured-case-study").forEach(function (el) {
		if (isElementInViewport(el)) {
            let picture = el.querySelector(":scope .picture-wrapper");
            if (picture) {
                picture.classList.add("slide-right");
            }
            el.querySelector(":scope .copy").classList.add("slide-left");
		}
	});
}
window.addEventListener("scroll", slideFeaturedCaseStudies);


/**
 *	BLOCK: FEATURED PEOPLE
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".ash-block.featured-people").forEach(function (el) {
		// Completely outside the viewport
		if (!isElementInViewport(el)) {
            el.querySelectorAll(":scope .ash-card.person-full").forEach(function (item) {
                item.classList.remove("slide");
            });
		}
	});
})();
// Add classes when any part within viewport
var slideFeaturedPeople = function () {
	document.querySelectorAll(".ash-block.featured-people").forEach(function (el) {
		if (isElementInViewport(el)) {
            el.querySelectorAll(":scope .ash-card.person-full").forEach(function (item) {
                item.classList.add("slide");
            });
		}
	});
}
window.addEventListener("scroll", slideFeaturedPeople);


/**
 *	BLOCK: LIST W/MEDIA
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".ash-block.list-media").forEach(function (el) {
		// Completely outside the viewport
		if (!isElementInViewport(el)) {
            el.querySelector(":scope .foreground").classList.remove("slide");
            let backgroundImg = el.querySelector(":scope .background");
            if (backgroundImg) {
                backgroundImg.classList.remove("slide");
            }

            el.querySelectorAll(":scope .text .overline, :scope .text .headline, :scope .text .desc, :scope .text .list-item").forEach(function (item) {
                item.classList.remove("slide");
            });

            el.querySelectorAll(":scope .ash-button").forEach(function (item) {
                item.classList.remove("fade");
            });
		}
	});
})();
// Add classes when any part within viewport
var slideListMedia = function () {
	document.querySelectorAll(".ash-block.list-media").forEach(function (el) {
		if (isElementInViewport(el)) {
            el.querySelector(":scope .foreground").classList.add("slide");
            let backgroundImg = el.querySelector(":scope .background");
            if (backgroundImg) {
                backgroundImg.classList.add("slide");
            }

            el.querySelectorAll(":scope .text .overline, :scope .text .headline, :scope .text .desc, :scope .text .list-item").forEach(function (item) {
                item.classList.add("slide");
            });

            el.querySelectorAll(":scope .ash-button").forEach(function (item) {
                item.classList.add("fade");
            });
		}
	});
}
window.addEventListener("scroll", slideListMedia);


/**
 *	BLOCK: MEDIA W/CALLOUT
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".ash-block.media-callout").forEach(function (el) {
		// Completely outside the viewport
		if (!isElementInViewport(el)) {
            el.querySelectorAll(":scope .overline, :scope .headline, :scope .desc, :scope .ash-button").forEach(function (item) {
                item.classList.remove("slide");
            });
		}
	});
})();
// Add classes when any part within viewport
var slideMediaCallout = function () {
	document.querySelectorAll(".ash-block.media-callout").forEach(function (el) {
		if (isElementInViewport(el)) {
            el.querySelectorAll(":scope .overline, :scope .headline, :scope .desc, :scope .ash-button").forEach(function (item) {
                item.classList.add("slide");
            });
		}
	});
}
window.addEventListener("scroll", slideMediaCallout);


/**
 *	BLOCK: ROW
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".ash-block.row").forEach(function (el) {
		// Completely outside the viewport
		if (!isElementInViewport(el)) {
            el.querySelectorAll(":scope .ash-card").forEach(function (item) {
                item.classList.remove("slide");
            });
		}
	});
})();
// Add classes when any part within viewport
var slideRow = function () {
	document.querySelectorAll(".ash-block.row").forEach(function (el) {
		if (isElementInViewport(el)) {
            el.querySelectorAll(":scope .ash-card").forEach(function (item) {
                item.classList.add("slide");
            });
		}
	});
}
window.addEventListener("scroll", slideRow);


/**
 *	BLOCK: SMALL ICON GRID
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".ash-block.small-icon-grid").forEach(function (el) {
		// Completely outside the viewport
		if (!isElementInViewport(el)) {
            el.querySelectorAll(":scope .icon").forEach(function (icon) {
                icon.classList.remove("slide-up");
            });
		}
	});
})();
// Add classes when any part within viewport
var slideSmallIconGrids = function () {
	document.querySelectorAll(".ash-block.small-icon-grid").forEach(function (el) {
		if (isElementInViewport(el)) {
            el.querySelectorAll(":scope .icon").forEach(function (icon) {
                icon.classList.add("slide-up");
            });
		}
	});
}
window.addEventListener("scroll", slideSmallIconGrids);


/**
 *	BLOCK: TEXT W/MEDIA
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".ash-block.text-media").forEach(function (el) {
		// Completely outside the viewport
		if (!isElementInViewport(el)) {
            el.querySelector(":scope .foreground").classList.remove("slide");
            let backgroundImg = el.querySelector(":scope .background");
            if (backgroundImg) {
                backgroundImg.classList.remove("slide");
            }

            el.querySelector(":scope .text").classList.remove("slide-fade");
		}
	});
})();
// Add classes when any part within viewport
var slideTextMedia = function () {
	document.querySelectorAll(".ash-block.text-media").forEach(function (el) {
		if (isElementInViewport(el)) {
            el.querySelector(":scope .foreground").classList.add("slide");
            let backgroundImg = el.querySelector(":scope .background");
            if (backgroundImg) {
                backgroundImg.classList.add("slide");
            }

            el.querySelector(":scope .text").classList.add("slide-fade");
		}
	});
}
window.addEventListener("scroll", slideTextMedia);


/**
 *	HISTORY TIMELINE
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll(".history-timeline .event").forEach(function (el) {
		// Completely outside the viewport
        if (!isElementInViewport(el)) {
            el.classList.remove("slide");
		}
	});
})();
// Add classes when any part within viewport
var slideHistoryEvents = function () {
	document.querySelectorAll(".history-timeline .event").forEach(function (el) {
		if (isElementInViewport(el)) {
			el.classList.add("slide");
		}
	});
}
window.addEventListener("scroll", slideHistoryEvents);